import ImageCard from "@components/ImageCard"
import { getIn } from "@utils/index"
import React from "react"

import { ContentfulContentBaseProps } from "../types"

interface ContentfulImageCardProps extends ContentfulContentBaseProps {}

const ContentfulImageCard: React.FC<ContentfulImageCardProps> = ({
  blockId,
  caption,
  description,
  image,
}) => {
  return (
    <ImageCard
      blockId={blockId}
      caption={caption}
      description={getIn(description, "description")}
      image={getIn(image, "file.url")}
    />
  )
}

export default ContentfulImageCard
